<!-- <app-search-events [isLive]="false"></app-search-events> -->
<section id="sportTree" class="sport-tree">
    <ul class="list">
      <li *ngIf="favoriteCompetitions.length > 0 && favoriteCompetitionsHaveOnlineEvents">
        <div class="sport-info" [class.open]="favoriteLeaguesIsExpanded" (click)="toggleFavoriteCompetitions()">
          <div class="name-wrap">
            <!-- <div class="icon-wrap"> -->
            <!-- <app-svg-icon iconId="star"></app-svg-icon> -->
            <i class="sporticon icon-width icon-sm sporticon-star m-r"></i>
            <!-- </div> -->
            <span class="name">{{dynamicTranslations.favoriteButtonName}}</span>
          </div>
        </div>
        <ul class="sub-list region-list" *ngIf="favoriteLeaguesIsExpanded && favoriteCompetitions.length > 0">
          <ng-container *ngFor="let competition of favoriteCompetitions">
            <li [class.selected]="competition.isSelected" *ngIf="competition.isShown"
              (click)="selectCompetitionFromFavorites(competition)">
              <div class="competition-info">
                <div class="flex">
                  <span class="icon-wrap" (click)="addRemoveCompetitionToFavorites(competition); $event.stopPropagation();">
                    <!-- <app-svg-icon iconId="{{competition.isInFavorites ? 'star' : 'star-empty'}}"></app-svg-icon> -->
                    <i
                      class="icon-width sporticon icon-xs sporticon-{{competition.isInFavorites ? 'star' : 'star-border'}}"></i>
                  </span>
                  <span class="region-name">{{competition.regionName}} {{competition.name}}</span>
                </div>
                <span class="events-name">{{competition.eventsCount}}</span>
              </div>
              <!-- <app-events-mobile *ngIf="competition.isSelected && favoriteLeaguesIsExpanded"></app-events-mobile> -->
              <app-sport-tree-selection-container-mobile *ngIf="competition.isSelected && favoriteLeaguesIsExpanded">
              </app-sport-tree-selection-container-mobile>
            </li>
          </ng-container>
        </ul>
      </li>
      <li *ngFor="let sport of sports;">
        <div class="sport-info" (click)="sport.id != -99 ? selectSport(sport): toggleMostPopularSports(sport);"
          *ngIf="sport.eventsCount>0 || sport.id == -99">
          <div class="name-wrap">
            <i class="icon-width sporticon icon-sm m-r sporticon-all" *ngIf="sport.id < 0">
              <sub *ngIf="sport.id == -1">{{dynamicTranslations.specialOfferEventsShorcutEventOfDay}}</sub>
              <sub *ngIf="sport.id == -2">{{dynamicTranslations.specialOfferEventsShorcutSuperBet}}</sub>
              <!-- <sub *ngIf="sport.id == -3">{{dynamicTranslations.specialOfferEventsShorcutOutrights}}</sub> -->
            </i>
            
            <i class="icon-sm m-r s-icon-{{getSportName(sport.id)}} sportid-{{sport.id}}" *ngIf="sport.id > 0"></i>
            <span class="name">{{sport.name}}</span>
          </div>

          <div class="events-count">
            {{sport.eventsCount}}
            <i class="arrow-down icon icon-xs icon-chevron-down"
              [class.closed]="((sport.id != -99 && sport.showRegions) || (sport.id == -99 && showMostPopularSports))"></i>
            <!-- <span class="arrow-down" [class.open]="sport.showRegions"></span> -->
          </div>
        </div>
        <app-special-events-mobile [specialOfferType]="sport.specialOfferType"
          *ngIf="sport.showRegions && (sport.specialOfferType || showMostPopularSports)">
        </app-special-events-mobile>

        <ul class="sub-list region-list"
          *ngIf="sport.showRegions && !favoriteLeaguesIsExpanded && !sport.specialOfferType && sport.eventsCount>0">
          <ng-container *ngFor="let region of sport.regions;">
            <ng-container *ngIf="!sport.specialOfferType; else specialEvents">
              <li [class.live]="isLive" *ngFor="let competition of region.competitions;"
                (click)="selectCompetition(competition, region, sport, $event); $event.stopPropagation();">
                <div class="competition-info" *ngIf="competition.eventsCount>0">
                  <div class="flex">
                    <span class="icon-wrap" (click)="addRemoveCompetitionToFavorites(competition); $event.stopPropagation();">
                      <i class="sporticon icon-xs sporticon-{{competition.isInFavorites ? 'star' : 'star-border'}}"></i>
                    </span>
                    <span class="region-name">{{competition.regionName}} {{competition.name}}</span>
                  </div>
                  <span class="events-count">
                    {{competition.eventsCount}}
                    <i class="arrow-down icon icon-xs icon-chevron-down" [class.closed]="competition.isSelected"></i>
                    <!-- <span class="arrow-down" [class.open]="competition.isSelected"></span> -->
                  </span>
                </div>
                <!-- <app-events-mobile *ngIf="competition.isSelected && !favoriteLeaguesIsExpanded"></app-events-mobile> -->
                <app-sport-tree-selection-container-mobile *ngIf="competition.isSelected && !favoriteLeaguesIsExpanded">
                </app-sport-tree-selection-container-mobile>
              </li>
            </ng-container>
            <ng-template #specialEvents>
              <li [class.live]="isLive">
                <div class="competition-info">
                  <div class="flex">
                    <span class="region-name">{{region.name}}</span>
                  </div>
                  <span class="events-count">
                    {{region.eventsCount}}
                    <span class="arrow-down" [class.open]="region.isSelected"></span>
                  </span>
                </div>
                <!-- <app-events-mobile *ngIf="region.isSelected"></app-events-mobile> -->
                <app-sport-tree-selection-container-mobile *ngIf="region.isSelected">
                </app-sport-tree-selection-container-mobile>
              </li>
            </ng-template>
          </ng-container>
        </ul>

      </li>



    </ul>

</section>
